import { ReactNode } from "react";

interface PanelFilterBarProps {
  children: ReactNode;
}

export default function PanelFilterBar({ children }: PanelFilterBarProps) {
  return (
    <div className="rounded-2xl border border-secondary/10 bg-white p-4 shadow-md shadow-secondary/5 md:p-5">
      <div className="flex flex-wrap items-center gap-3">{children}</div>
    </div>
  );
}
